export default "__VITE_ASSET__DN5NA8ig__"